const COD_SUSCRIPCION = 2;

export const esSuscripcion = (tinCodProductoFormaComercializacion?: number | null): boolean =>
    tinCodProductoFormaComercializacion === COD_SUSCRIPCION;

export const sufijoPrecio = (tinCodProductoFormaComercializacion?: number | null): string =>
    esSuscripcion(tinCodProductoFormaComercializacion) ? " / mes" : "";
